import React from 'react'
import styled from 'styled-components'
import cloneDeep from 'lodash/cloneDeep'
import { merge } from 'lodash'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next';
import { FlexContainer, device, useWindowSize } from 'heliocor-ui'
import 'styled-components/macro'

import CommonTitle from '../../common/CommonTitle'
import { SummaryList } from './section/SummaryList'
import { SummaryStructure } from './section/SummaryStructure'
import { SummaryDocuments } from './section/SummaryDocuments'
import { STRUCTURE_COLUMNS_SUMMARY } from '../structures/table'
import { getFieldsInformation, getSummaryDetails } from '../../utils/summary'

const ResumeBox = styled(FlexContainer)`
    margin: 0;
    @media ${device.midSize}{
        margin: 0 2rem;
    }
`

const ApplicationSummary = ({ entity, connectedParties, documents, partyType, handleChangeStep, canEdit, id, stepsList = [] }) => {
    let isSummary = id === 'summary'

    const { t } = useTranslation()
    const { isMobile } = useWindowSize()
    const settings = useSelector(state => state.settings)
    const isRequest = useSelector(state => state.config.isRequest)
    const customFields = cloneDeep(settings.customFields)
    const prevDetails = cloneDeep(settings.previousPartyDetailsFields)

    const summaryFields = isSummary ? merge(prevDetails, customFields) : prevDetails;

    const entityDetails = getSummaryDetails({ 
        isSummary,
        customFields,
        prevDetails,
        partyType,
        isRequest
    })[partyType]

    const getComponent = ({ titleId, fields, labels }) => ({
        FIELDS: {
            component: SummaryList,
            props: {
                data: entity,
                fields: fields,
                fieldsInfo: getFieldsInformation(summaryFields),
                title: titleId,
                labels: labels,
                handleChangeStep,
                canEdit: (canEdit && stepsList.includes(titleId))
            }
        },
        STRUCTURE: {
            component: SummaryStructure,
            props: {
                data: connectedParties,
                columns: STRUCTURE_COLUMNS_SUMMARY(t, isMobile),
                title: titleId,
                handleChangeStep,
                canEdit
            }
        },
        DOCUMENTS: {
            component: SummaryDocuments,
            props: {
                data: documents,
                title: partyType === 'COMPANY' ? 'COMPANY_DOCUMENTS' : 'DOCUMENTS'
            }
        }
    })

    return (
        <React.Fragment>
            <CommonTitle translate={id} />
            <ResumeBox column>
                {entityDetails.map(({ titleId, fields, labels }, i) => {
                    const sectionType = fields ? 'FIELDS' : titleId
                    const section = getComponent({ titleId, fields, labels })[sectionType]
                    return React.createElement(section.component, {...section.props, key: i})
                })}
            </ResumeBox>
        </React.Fragment>
    )
}

export { ApplicationSummary }